module.exports = __webpack_public_path__ + "img/opera.dda1a620.svg";